$(document).on('ready', () => {
	$('.readmore').not('[data-slide-target]').each(function() {
		let $button = $(this);
		let $expandable = $button.parent().find('.content');
		let $card = $button.closest('.expandingcard');
		let $cardparent = $card.parent();
		let styleString = $card.attr('style');
		if (styleString == 'undefined' || typeof styleString === 'undefined') {
			styleString = '';
		}

		$card.attr('style', styleString + 'height: ' + $card.outerHeight() + 'px;');

		$button.on('click', (e) => {
			e.preventDefault();
			$expandable.toggleClass('expanded');
			$card.toggleClass('expanded');
			$cardparent.toggleClass('expanded');
			$button.find('i.fas').toggleClass('fa-angle-down fa-angle-up');
		})
	})
})